module.exports = __webpack_public_path__ + "static/media/notificationsSuccess.8c0473ec.svg";